import { convertGoalListResponseToGoalsListItem } from './useFilteredGoals'
import useGoals from './useGoals'

type useGoalsIDsProps = {
  residentID: string | undefined
  goalsIDs: string[]
}

const useGoalsIDs = (props: useGoalsIDsProps) => {
  const { residentID: id, goalsIDs } = props

  const { goals } = useGoals(id)
  const linkedGoals = goals?.filter((goal) => goalsIDs?.includes(goal.id))

  const convertedGoals = linkedGoals?.map((goal) =>
    convertGoalListResponseToGoalsListItem(goal)
  )

  return {
    filteredGoals: convertedGoals,
    goals
  }
}

export default useGoalsIDs
